import useUser from '@hooks/auth/useUser';
import useScript from '@hooks/useScript';
import { useEffect } from 'react';

export interface FingerPayFormProps {
    orderNo: string;
    mallId: string;
    requestedAt: string;
    hashString: string;
    itemName: string;
    paymentAmount: number;
    returnUri: string;
}

function useFingerPay() {
  const { user } = useUser();
  useScript({ src: 'https://pay-dev.fingerservice.co.kr/js/pgAsistant.js' });
  useEffect(() => {
    // @ts-ignore
    window.pay_result_submit = () => {
      // @ts-ignore
      payResultSubmit();
    };
    // @ts-ignore
    window.pay_result_close = () => {
      console.log('결제창 닫기');
    };

    return () => {
      // @ts-ignore
      window.pay_result_submit = undefined;
      // @ts-ignore
      window.pay_result_close = undefined;
    };
  }, []);

  return (props: FingerPayFormProps) => {
    const {
      mallId, hashString, requestedAt, orderNo, itemName, paymentAmount, returnUri,
    } = props;
    const form = document.createElement('form');
    form.name = 'payInit';
    form.method = 'post';
    form.action = '';
    form.hidden = true;
    const payMethod = document.createElement('input');
    payMethod.name = 'payMethod';
    payMethod.value = 'CARD';
    form.append(payMethod);
    const mid = document.createElement('input');
    mid.name = 'mid';
    mid.value = mallId;
    form.append(mid);
    const payType = document.createElement('input');
    payType.name = 'payType';
    payType.value = 'AUTH';
    form.append(payType);
    const goodsNm = document.createElement('input');
    goodsNm.name = 'goodsNm';
    goodsNm.value = itemName;
    form.append(goodsNm);
    const ordNo = document.createElement('input');
    ordNo.name = 'ordNo';
    ordNo.value = orderNo;
    form.append(ordNo);
    const ordNm = document.createElement('input');
    ordNm.name = 'ordNm';
    ordNm.value = user?.nickname || '고객님';
    form.append(ordNm);
    const returnUrl = document.createElement('input');
    returnUrl.name = 'returnUrl';
    returnUrl.value = `${import.meta.env.VITE_API_URL}${returnUri}`;
    form.append(returnUrl);
    const ediDate = document.createElement('input');
    ediDate.name = 'ediDate';
    ediDate.value = requestedAt;
    form.append(ediDate);
    const hashStr = document.createElement('input');
    hashStr.name = 'hashString';
    hashStr.value = hashString;
    form.append(hashStr);
    const goodsAmt = document.createElement('input');
    goodsAmt.name = 'goodsAmt';
    goodsAmt.value = `${paymentAmount}`;
    form.append(goodsAmt);
    document.body.append(form);

    // @ts-ignore
    SendPay(document.payInit, 'TEST');
    return () => {
      form.remove();
    };
  };
}

export default useFingerPay;
